module.exports = "<app-toolbar  [logged-in]=\"false\"></app-toolbar>\r\n<div class='not-found-message' >\r\n  <h3>\r\n    Page not found :(\r\n  </h3>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/not-found/not-found.component.html
// module id = ./src/app/not-found/not-found.component.html
// module chunks = main